import * as classes from './classes';
import * as utility from './utility';

export function workerTouchedPlant(worker, plant)
{

	// Only do this if the worker's target hasn't been changed for awhile.
	if (worker.targetRecentlyChanged == false &&
		worker.scene.colliders.workerTouchedPlantOverlap.active)
	{

		if (!worker.scene.colliders.workerTouchedPlantOverlap.temporarilyDisabled)
		{
			worker.scene.colliders.workerTouchedPlantOverlap.active = false;
			worker.scene.colliders.workerTouchedPlantOverlap.temporarilyDisabled = true;
			setTimeout(() => {
				if(worker.scene)
				{
					worker.scene.colliders.workerTouchedPlantOverlap.active = true;
					worker.scene.colliders.workerTouchedPlantOverlap.temporarilyDisabled = false;
				}

			}, 10)
		}


		// console.log("Worker touched plant.");

		var maybeThePollenDoesNotSpawn = Phaser.Math.RND.integerInRange(0,3);

		if (maybeThePollenDoesNotSpawn == 0)
		{
			var numberOfPollensToSpawn = 3;
			if (worker.species == 'bumble')
			{
			  numberOfPollensToSpawn = 7;
			}
			for (var i = 0; i < numberOfPollensToSpawn; i++)
			{
				var xVariation = Phaser.Math.RND.integerInRange(-100,100);
				var yVariation = Phaser.Math.RND.integerInRange(-100,100);

				worker.scene.pollens.push( new classes.Pollens(worker.scene, plant.x + xVariation, plant.y + yVariation) );
			}
		}

		worker.targetRecentlyChanged = true;

		// Pick a hive to go to after a few seconds.
		var changeTargetToCellTimer = worker.scene.time.addEvent(
			{
				delay: 5000,
				callback: function changeTargetToCell() {
					if (worker.scene && worker.isWorker)
					{
						worker.target = utility.closestCell(worker.scene, worker);
						worker.carryingNectar = true;
					}
				},
				callbackScope: this,
				loop: false
			}
		);

		var recentlyChangedTargetTimer = worker.scene.time.addEvent(
			{
				delay: 10000,
				callback: function targetNoLongerRecentlyChanged() {
					worker.targetRecentlyChanged = false;
				},
				callbackScope: this,
				loop: false
			}
		);

	}
}

export function workerTouchedWasp(worker, wasp)
{
	try {
		// Harm wasp and worker.
		wasp.hitPoints -= 5;
		worker.parent.setAttackAnimation(worker);
		worker.parent.healthChange(worker, 'hurt', 15);
		wasp.parent.setAttackAnimation(wasp);

		if (wasp.hitPoints < 1)
		{
			wasp.parent.dies(wasp);
		}
	} catch (e) {
		console.log('There was an error when a worker touched a wasp: ', e);
	}

}

export function workerTouchedYellowJacket(worker, yellowJacket)
{
	try
	{
		// Harm wasp and worker.
		if (worker.alarmPheromoneParticles.emitting)
		{
			yellowJacket.hitPoints -= 10;
			worker.parent.healthChange(worker, 'hurt', 10);
			worker.parent.setAttackAnimation(worker);
		} else {
			worker.parent.healthChange(worker, 'hurt', 25);
		}

		yellowJacket.parent.setAttackAnimation(yellowJacket);

		if (yellowJacket.hitPoints < 1)
		{
			yellowJacket.parent.dies(yellowJacket);
		}
	} catch (e) {
		console.log('There was an error when a worker touched a yellow jacket: ', e);
	}

}

export function queenBeeTouchedWasp(queenBee, wasp)
{
	try
	{
		// Harm wasp and queenBee.
		if (queenBee.parent.alarmPheromoneParticles.emitting)
		{
			wasp.hitPoints -= 5;
			queenBee.parent.healthChange(queenBee, 'hurt', 10);
			queenBee.parent.setAttackAnimation(queenBee);
		} else {
			queenBee.parent.healthChange(queenBee, 'hurt', 25);
		}

		wasp.parent.setAttackAnimation(wasp);

		if (wasp.hitPoints < 1)
		{
			wasp.parent.dies(wasp);
		}
	} catch (e) {
		console.log('There was an error when a queenBee touched a wasp: ', e);
	}
}

export function queenBeeTouchedYellowJacket(queenBee, yellowJacket)
{
	try {
		// Harm wasp and/or worker.
		if (queenBee.parent && queenBee.parent.alarmPheromoneParticles.emitting)
		{
			yellowJacket.hitPoints -= 15;
			queenBee.parent.healthChange(queenBee, 'hurt', 10);
			queenBee.parent.setAttackAnimation(queenBee);
		} else {
			queenBee.parent.healthChange(queenBee, 'hurt', 25);
		}

		yellowJacket.parent.setAttackAnimation(yellowJacket);

		if (yellowJacket.hitPoints < 1)
		{
			yellowJacket.parent.dies(yellowJacket);
		}
	} catch (e) {
		console.log('There was an error when a queen bee touched a yellowjacket: ', e);
	}

}

export function yellowJacketTouchedWasp(yellowJacket, wasp)
{
	try {
		// Harm yellowJacket and wasp.
		yellowJacket.hitPoints -= 20;
		wasp.hitPoints -= 10;

		// Animations
		yellowJacket.parent.setAttackAnimation(yellowJacket);
		wasp.parent.setAttackAnimation(wasp);

		// They can die.
	   if (yellowJacket.hitPoints < 1)
	   {
		   yellowJacket.parent.dies(yellowJacket);
	   }
	   if (wasp.hitPoints < 1)
	   {
		   wasp.parent.dies(wasp);
	   }
	} catch (e) {
		console.log('There was an error when a wasp touched a yellowjacket: ', e);
	}
}

export function waspTouchedBrood(wasp, brood)
{
	try {
		brood.parent.dies(brood);
	} catch(e) {
		console.log("There was an error when wasp touched brood: ", e);
	}

}

export function yellowJacketTouchedBrood(yellowJacket, brood)
{
	try
	{
		if (!yellowJacket.carryingBrood && brood.broodStage != 'pupaYellowjacket')
		{
			// Not already carrying brood and it wasn't a yellowjacket pupa touched.
			// Steal brood and bring it home to babies.
			yellowJacket.carryingBrood = true;
			yellowJacket.targetRecentlyChanged = true;
			brood.carriedBy = yellowJacket;

			yellowJacket.broodCarriedGroup.add(brood);
			brood.scene.broodsGroup.remove(brood);

			// Set Scene on all children in the broodsCarriedGroup
			// because for some reason that gets unset before we set depth on them.
			var childrenBroods = yellowJacket.broodCarriedGroup.getChildren();
			if (childrenBroods.length > 0)
			{
				for (var i = 0; i < childrenBroods.length; i++)
				{
					childrenBroods[i].scene = yellowJacket.scene;
				}
			}
			yellowJacket.broodCarriedGroup.setDepth(100);

			yellowJacket.target = utility.closestEmptyYellowJacketCell(yellowJacket.scene, yellowJacket);
			yellowJacket.task = 'headedBackToHiveWithBrood';

			console.log('YellowJacket headed to its hive.');

		} else if (yellowJacket.carryingBrood && brood.broodStage == 'pupaYellowjacket') {
			// Already carrying brood and the brood is a yellow jacket pupa.
			// Feed carried brood to yellow jacket pupa creating a new yellow jacket.
			var childrenBroods = yellowJacket.broodCarriedGroup.getChildren();
			for (var i = 0; i < childrenBroods.length; i++)
			{
				yellowJacket.scene.yellowJacketPupaBecomesYellowJacket(yellowJacket.scene, childrenBroods[i]);
				// Destroy the carried brood.
				yellowJacket.broodCarriedGroup.remove(childrenBroods[i], true);
				brood.broodStage = null;
				console.log('Yellow jacket fed brood to their young.');
			}
			yellowJacket.carryingBrood = false;
			// Destroy the touched brood.
			brood.scene.broodsGroup.remove(brood);
			brood.destroy();
		}
	} catch (error) {
		console.log('Error occurred when a yellowJacket touched brood.', error);
	}
}

export function yellowJacketTouchedCell(yellowJacket, cell)
{
	try
	{
		// if (yellowJacket.task == 'headedBackToHiveWithBrood')
		// {
		//     yellowJacket.task = 'kill';
		//     // Kill all carried brood.
		//     var childrenBroods = yellowJacket.broodCarriedGroup.getChildren();
		//     for (var i = 0; i < childrenBroods.length; i++)
		//     {
		//         yellowJacket.parent.layEgg(yellowJacket);
		//
		//         // Kill the carried brood.
		//         yellowJacket.scene.broodDies(childrenBroods[i]);
		//
		//         console.log('Yellow jacket fed brood to their young.');
		//     }
		// }
	} catch (error) {
		console.log('Error occurred when a yellowJacket touched a cell.', error);
	}
}

export function workerTouchedVarroaMite(worker, varroaMite)
{
	if (!varroaMite.touchedBrood && !worker.alarmPheromoneParticles.emitting)
	{
		worker.varroaMitesCarriedGroup.add(varroaMite);
		// varroaMite.scene.varroaMitesGroup.remove(varroaMite);

		varroaMite.workerCarriedBy = worker;

		// Set Scene on all children in the pollenCarriedGroup
		// because for some reason that gets unset before we set depth on them.
		var childrenVarroaMites = worker.varroaMitesCarriedGroup.getChildren();
		if (childrenVarroaMites.length > 0)
		{
			for (var i = 0; i < childrenVarroaMites.length; i++)
			{
				childrenVarroaMites[i].scene = worker.scene;
			}
		}

		worker.hasMites = true;

		worker.varroaMitesCarriedGroup.setDepth(100);
	}

	if (worker.alarmPheromoneParticles.emitting)
	{
		worker.parent.setAttackAnimation(worker);
		varroaMite.hitPoints -= 25;

		if (varroaMite.hitPoints < 1)
		{
			varroaMite.parent.dies(varroaMite);
		}
	}
}

export function queenBeeTouchedVarroaMite(queenBee, varroaMite)
{
	if (queenBee.parent.alarmPheromoneParticles.emitting)
	{
		queenBee.parent.setAttackAnimation(queenBee);
		varroaMite.hitPoints -= 25;

		if (varroaMite.hitPoints < 1)
		{
			varroaMite.parent.dies(varroaMite);
		}
	}
}

export function workerTouchedWorker(worker1, worker2)
{
	try {
		// Groom the other worker if they're a friend with mites and we're a nurse.
		if (worker1.username == worker2.username)
		{
			if ( (worker1.role == 'nurse' && worker1.target == worker2 && !worker2.isBeingGroomed) ||
				 (worker2.role == 'nurse' && worker2.target == worker1 && !worker1.isBeingGroomed))
			{
				worker1.parent.workerGroomsWorker(worker1, worker2);
			}
		}

		// Attack enemy workers if the alarm pheromone is active.

		// First worker
		if (
			(worker1.alarmPheromoneParticles.emitting) &&
			worker1.username != worker2.username
		   )
		{
			worker1.parent.setAttackAnimation(worker1);
			worker2.parent.healthChange(worker2, 'hurt', 10);
		}

		// Second worker
		if (
			(worker2.alarmPheromoneParticles.emitting) &&
			worker1.username != worker2.username
		   )
		{
			worker2.parent.setAttackAnimation(worker2);
			worker1.parent.healthChange(worker1, 'hurt', 10);
		}

	} catch(e) {
	  console.log("There was an error after worker touched worker: ", e);
	}


}

export function pondTouchedPlant(pond, plant)
{
	try
	{
		if (plant.plantSpine)
		{
			plant.plantSpine.destroy();
		}

		if (plant.plantShadowSprite)
		{
			plant.plantShadowSprite.destroy();
		}

		if (plant.treeSpine)
		{
			plant.treeSpine.destroy();
		}

		if (plant.treeShadowSprite)
		{
			plant.treeShadowSprite.destroy();
		}

		if (plant.scene)
		{
			plant.scene.plantsGroup.remove(plant);
		}
		plant.destroy();
	} catch (error) {
		console.log('Error occurred when destroying a plant for touching a pond.', error);
	}
}

export function workerTouchedQueenBee(worker, queenBee)
{
	try {
		if (worker.username != queenBee.username)
		{
			// Worker and queen are not from the same colony.
			if ( worker.alarmPheromoneParticles.emitting ||
				(queenBee.parent && queenBee.parent.alarmPheromoneActive) )
			{
				// Hurt the queen.
				worker.parent.setAttackAnimation(worker);
				queenBee.parent.healthChange(queenBee, 'hurt', 1);
				// Hurt the worker.
				queenBee.parent.setAttackAnimation(queenBee);
				worker.parent.healthChange(worker, 'hurt', 2);
			}
		}
	} catch (e) {
		console.log('There was an error when worker touched queen bee: ', e);
	}
}

export function queenBeeTouchedQueenBee(queenBee1, queenBee2)
{
	try {
		if (queenBee1.parent && queenBee1.parent.alarmPheromoneActive)
		{
			queenBee1.parent.setAttackAnimation(queenBee1);
			queenBee2.parent.healthChange(queenBee2, 'hurt', 1);
		}
		if (queenBee2.parent && queenBee2.parent.alarmPheromoneActive)
		{
			queenBee2.parent.setAttackAnimation(queenBee2);
			queenBee1.parent.healthChange(queenBee1, 'hurt', 1);
		}
	} catch (e) {
		console.log('There was an error when a queen bee touched another queen bee: ', e);
	}
}

export function workerTouchedHive(worker, hive)
{
	if (worker.targetRecentlyChanged == false)
	{
		worker.targetRecentlyChanged = true;

		switch(worker.role)
		{
			case 'forager':
				worker.task = 'Heading to forage flowers.';
				worker.target = Phaser.Math.RND.pick(worker.scene.plantsGroup.children.entries);
				break;
			case 'nurse':
				// Determine nearest varroa-infested cell.
				let closestBroodWithMites = utility.closestBroodWithMites(worker.scene, worker);
				let distanceToClosestBroodWithMites;
				if (closestBroodWithMites)
				{
					distanceToClosestBroodWithMites = Phaser.Math.Distance.Between(worker.x, worker.y, closestBroodWithMites.x, closestBroodWithMites.y);
				}
				// Determine nearest varroa-infested worker.
				let closestWorkerWithMites = utility.closestWorkerWithMites(worker.scene, worker);
				let distanceToClosestWorkerWithMites;
				if (closestWorkerWithMites)
				{
					distanceToClosestWorkerWithMites = Phaser.Math.Distance.Between(worker.x, worker.y, closestWorkerWithMites.x, closestWorkerWithMites.y);
				}
				// Deal with varroa mite removal, otherwise, bring food to babies.
				if (distanceToClosestBroodWithMites &&
					distanceToClosestBroodWithMites < 700)
				{
					worker.task = 'Heading to groom a brood with mites.';
					worker.target = closestBroodWithMites;

				} else if (distanceToClosestWorkerWithMites && distanceToClosestWorkerWithMites < 700)
				{
					worker.task = 'Heading to groom a worker with mites.';
					worker.target = closestWorkerWithMites;
				} else if (worker.scene.beeBreadsGroup.children.length > 0)
				{
					worker.task = 'Heading to pick up bee bread.';
					worker.target = Phaser.Math.RND.pick(worker.scene.beeBreadsGroup.children.entries);
				}
				break;
			case 'builder':
				worker.task = 'Heading to build a hive cell.';
				worker.target = Phaser.Math.RND.pick(worker.scene.cellsThatCanBeBuiltUponVerticallyGroup.children.entries);
				break;
		}

		var recentlyChangedTargetTimer = worker.scene.time.addEvent(
			{
				delay: 5000,
				callback: function targetNoLongerRecentlyChanged() {
					worker.targetRecentlyChanged = false;
				},

				callbackScope: this,
				loop: false
			}
		);

	}
}

export function beeTouchedPollen(bee, pollen)
{
	try
	{
		if (bee.pollenCarriedGroup)
		{
			bee.pollenCarriedGroup.add(pollen);
		}
		pollen.scene.pollensGroup.remove(pollen);

		if (bee.pollenCarriedGroup)
		{
			// Set Scene on all children in the pollenCarriedGroup
			// because for some reason that gets unset before we set depth on them.
			var childrenPollens = bee.pollenCarriedGroup.getChildren();
			if (childrenPollens.length > 0)
			{
				for (var i = 0; i < childrenPollens.length; i++)
				{
					childrenPollens[i].scene = bee.scene;
				}
			}
			bee.pollenCarriedGroup.setDepth(100);
		}
	} catch(error) {
		console.log('Error occurred when a bee touched pollen.', error);
	}

}

export function beeTouchedBeeBread(bee, beeBread)
{
	try
	{
		if (bee.role == 'nurse' && !bee.carryingBeeBread)
		{
			bee.carryingBeeBread = true;
			bee.targetRecentlyChanged = true;
			beeBread.parent = bee;

			bee.beeBreadCarriedGroup.add(beeBread);
			beeBread.scene.beeBreadsGroup.remove(beeBread);

			// Set Scene on all children in the pollenCarriedGroup
			// because for some reason that gets unset before we set depth on them.
			var childrenBeeBreads = bee.beeBreadCarriedGroup.getChildren();
			if (childrenBeeBreads.length > 0)
			{
				for (var i = 0; i < childrenBeeBreads.length; i++)
				{
					childrenBeeBreads[i].scene = bee.scene;
				}
			}
			bee.beeBreadCarriedGroup.setDepth(100);

			if (bee.scene.broods.length > 0)
			{
				bee.target = utility.closestLarva(bee.scene, bee);
				bee.task = 'Bringing bee bread to nearest larva.';

			} else if (bee.targetRecentlyChanged == false) {
				var recentlyChangedTargetTimer = bee.scene.time.addEvent(
					{
						delay: 5000,
						callback: function targetNoLongerRecentlyChanged() {
							bee.targetRecentlyChanged = false;
						},

						callbackScope: this,
						loop: false
					}
				);
			}
		}
	} catch (error) {
		console.log('Error occurred when a bee touched bee bread.', error);
	}

}

export function workerTouchedHoney(worker, honey)
{
	// Builders eat honey before building a cell.
	if (worker.role == 'builder')
	{
		if (worker.isHungry == true)
		{
			honey.scene.honeysGroup.remove(honey);
			honey.destroy();

			worker.isHungry = false;
			worker.numberOfCellsWorkerCanBuildBeforeEating = 5;

			var cellDirections = ['vertical', 'left, right'];
			var randomCellDirection = Phaser.Math.RND.pick(cellDirections);
			switch (randomCellDirection)
			{
				case 'vertical':
					worker.target = Phaser.Math.RND.pick(worker.scene.cellsThatCanBeBuiltUponVerticallyGroup.children.entries);
					break;
				case 'left':
					worker.target = Phaser.Math.RND.pick(worker.scene.cellsThatCanBeBuiltUponToTheLeftGroup.children.entries);
					break;
				case 'right':
					worker.target = Phaser.Math.RND.pick(worker.scene.cellsThatCanBeBuiltUponToTheRightGroup.children.entries);
					break;
			}
			worker.task = 'Heading to build hive cells.';
			// console.log('A builder is headed to a buildable cell. New target:', worker.target);
		}

	}

}

export function beeBreadTouchedBrood(beeBread, brood)
{
	try {
		if (brood.broodStage == 'larva')
		{
			brood.broodStage = 'pupa';
			brood.setTexture('sprites', 'pupa.png');
			if (beeBread.parent)
			{
				beeBread.parent.carryingBeeBread = false;
			}
			beeBread.scene.beeBreadsGroup.remove(beeBread, true);
			beeBread.destroy();

			var pupaBecomesWorker = brood.scene.tweens.add({
				targets: brood,
				alpha: '0',
				delay: 10000,
				duration: 250,
				ease: 'Sine',
				onComplete: brood.parent.pupaBecomesWorker
			});
		}
	} catch(error) {
		console.log('Error occurred when a bee bread touched brood.', error);
	}
}

export function varroaMiteTouchedBrood(varroaMite, brood)
{

	brood.varroaMitesCarriedGroup.add(varroaMite);

	if (varroaMite.workerCarriedBy)
	{
		varroaMite.workerCarriedBy.varroaMitesCarriedGroup.remove(varroaMite);
		if (varroaMite.workerCarriedBy.varroaMitesCarriedGroup.getLength() == 0 &&
			varroaMite.workerCarriedBy.hasMites)
		{
			varroaMite.workerCarriedBy.hasMites = false;
			// console.log('Worker no longer has mites because they dropped them off on a baby.');
		}
	}

	// Set Scene on all children in the varroaMitesCarriedGroup
	// because for some reason that gets unset before we set depth on them.
	var childrenVarroaMites = brood.varroaMitesCarriedGroup.getChildren();
	if (childrenVarroaMites.length > 0)
	{
		for (var i = 0; i < childrenVarroaMites.length; i++)
		{
			childrenVarroaMites[i].scene = brood.scene;
		}
	}

	brood.varroaMitesCarriedGroup.setDepth(100);

	varroaMite.touchedBrood = true;
	brood.hasMites = true;

	setTimeout(function()
	{
		if(varroaMite.active == true && !varroaMite.reproduced && varroaMite.ableToReproduce)
		{
			varroaMite.reproduced = true;
			varroaMite.parent.reproduces(varroaMite, brood);
			brood.parent.dies(brood);
		}
	}, 10000);

}

export function workerTouchedCell(worker, cell)
{
	try
	{
		switch(cell.typeOfCell)
		{
			case 'empty':
				if (worker.pollenCarriedGroup)
				{
					var childrenPollens = worker.pollenCarriedGroup.getChildren();
					if (childrenPollens.length > 0)
					{
						cell.typeOfCell = 'pollenStorage';
						for (var i = 0; i < childrenPollens.length; i++)
						{
							var randomVariationX = Phaser.Math.RND.integerInRange(-10, 10);
							var randomVariationY = Phaser.Math.RND.integerInRange(-10, 10);
							childrenPollens[i].x = cell.x + randomVariationX;
							childrenPollens[i].y = cell.y + randomVariationY;
							cell.pollenStorageGroup.add(childrenPollens[i]);
							worker.pollenCarriedGroup.remove(childrenPollens[i]);
						}
					} else if (worker.carryingNectar == true)
					{
						worker.carryingNectar = false;
						cell.typeOfCell = 'honeyStorage';
						let newHoney;
						cell.scene.honeys.push( newHoney = new classes.Honeys(cell.scene, cell.x, cell.y, cell.scene.username, cell.scene.honeys.length, cell, cell.species) );
						cell.honeyStorageGroup.add(newHoney.honeySprite);
						utility.setDepthOfGroups(cell.scene);
					}
				}
				break;

			case 'pollenStorage':
				if (worker.pollenCarriedGroup)
				{
					var childrenPollens = worker.pollenCarriedGroup.getChildren();
					var maximumPollenInStorage = 20;
					if (childrenPollens.length > 0 && childrenPollens.length < maximumPollenInStorage)
					{
						for (var i = 0; i < childrenPollens.length; i++)
						{
							// Pollen gets stored.
							var randomVariationX = Phaser.Math.RND.integerInRange(-10, 10);
							var randomVariationY = Phaser.Math.RND.integerInRange(-10, 10);
							childrenPollens[i].x = cell.x + randomVariationX;
							childrenPollens[i].y = cell.y + randomVariationY;
							cell.pollenStorageGroup.add(childrenPollens[i]);
							worker.pollenCarriedGroup.remove(childrenPollens[i]);
						}
					} else {
						// Bee bread gets made.
						cell.typeOfCell = 'empty';
						for (var i = 0; i < childrenPollens.length; i++)
						{
							cell.pollenStorageGroup.remove(childrenPollens[i], true);
							childrenPollens[i].destroy;
							// console.log('childrenPollens[i]', childrenPollens[i]);
						}

						worker.scene.beeBreads.push( new classes.BeeBreads(worker.scene, cell.x, cell.y, null, null, worker.species) );
					}
				}
				break;

			case 'honeyStorage':
				if (worker.carryingNectar == true)
				{
					worker.carryingNectar = false;
					cell.honeyStored += 1;
				}
				break;
		}
	} catch(error)
	{
		console.log('Error having something touch a cell.', error);
	}
}

export function workerTouchedBrood(worker, brood)
{
	// Groom the brood with mites if we're a nurse.
	if (worker.role == 'nurse' &&
		worker.target == brood &&
		brood.hasMites &&
		!brood.isBeingGroomed)
	{
		worker.parent.workerGroomsBrood(worker, brood);
	}
}

export function workerTouchedCellThatCanBeBuiltUponVertically(worker, cell)
{
	if (worker.role == 'builder' && worker.isHungry == false && worker.recentlyTouchedBuilableCell == false)
	{

		worker.recentlyTouchedBuilableCell = true;
		worker.numberOfCellsWorkerCanBuildBeforeEating -= 1;
		if (worker.numberOfCellsWorkerCanBuildBeforeEating = 0)
		{
			worker.isHungry = true;
		}

		var builtCell;

		// New cell gets created above or below the cell.
		switch (cell.columnDirection)
		{
			case 'up':
				cell.scene.cells.push( builtCell = new classes.Cells(
					cell.scene,
					cell.x,
					cell.y - (cell.height - 5),
					this,
					'empty',
					true,
					cell.columnDirection,
					cell.scene.username,
					worker.species
				) );
				break;
			case 'down':
				cell.scene.cells.push( builtCell = new classes.Cells(
					cell.scene,
					cell.x,
					cell.y + (cell.height - 5),
					this,
					'empty',
					true,
					cell.columnDirection,
					cell.scene.username,
					worker.species
				) );
				break;
		}

		// Newest cell can be a builder target.
		// builtCell.canBeBuiltUpon = true;
		// builtCell.direction = cell.direction;
		builtCell.debugBodyColor = 0;
		cell.scene.cellsThatCanBeBuiltUponVerticallyGroup.add(builtCell.cellSprite);

		// Touched cell is no longer buildable.
		cell.canBeBuiltUpon = false;
		cell.debugBodyColor = 16711935;
		cell.scene.cellsThatCanBeBuiltUponVerticallyGroup.remove(cell);

		// Builder changes target to new buildable cell.
		// worker.target = Phaser.Math.RND.pick(worker.scene.cellsThatCanBeBuiltUponVerticallyGroup.children.entries);

		var recentlyChangedTargetTimer = worker.scene.time.addEvent(
			{
				delay: 5000,
				callback: function targetNoLongerRecentlyChanged() {
					worker.recentlyTouchedBuilableCell = false;
				},

				callbackScope: this,
				loop: false
			}
		);

		if (worker.scene.honeysGroup.children.entries.length > 0)
		{
			worker.target = Phaser.Math.RND.pick(worker.scene.honeysGroup.children.entries);
			worker.task = 'Heading to eat honey.';
		} else
		{
			worker.target = Phaser.Math.RND.pick(worker.scene.cellsGroup.children.entries);
			worker.task = 'Heading to a hive cell.';
		}

	} else if (worker.role == 'builder' && worker.isHungry == true)
	{
		if (worker.scene.honeysGroup.children.entries.length > 0)
		{
			worker.target = Phaser.Math.RND.pick(worker.scene.honeysGroup.children.entries);
			worker.task = 'Heading to eat honey.';
		} else if (worker.recentlyChangedTargetTimer == false)
		{
			worker.target = Phaser.Math.RND.pick(worker.scene.cellsGroup.children.entries);
			worker.task = 'Heading to a hive cell.';
		}
	}
}

export function workerTouchedCellThatCanBeBuiltUponToTheRight(worker, cell)
{
	if (worker.role == 'builder' && worker.isHungry == false && worker.recentlyTouchedBuilableCell == false)
	{
		worker.recentlyTouchedBuilableCell = true;
		worker.numberOfCellsWorkerCanBuildBeforeEating -= 1;
		if (worker.numberOfCellsWorkerCanBuildBeforeEating = 0)
		{
			worker.isHungry = true;
		}

		var builtCell;

		// New cell gets created to the right of the cell.
		cell.scene.cells.push( builtCell = new classes.Cells(
			cell.scene,
			cell.x + (cell.width + 18),
			cell.y - (cell.height - 5),
			this,
			'empty',
			true,
			cell.columnDirection,
			cell.scene.username,
			worker.species
		) );

		// Newest cell can be a builder target.
		// builtCell.canBeBuiltUpon = true;
		// builtCell.direction = cell.direction;
		builtCell.debugBodyColor = 0;
		builtCell.columnNumber = cell.columnNumber + 1;
		cell.scene.cellsThatCanBeBuiltUponVerticallyGroup.add(builtCell.cellSprite);
		cell.scene.cellsThatCanBeBuiltUponToTheRightGroup.add(builtCell.cellSprite);

		// Touched cell is no longer buildable.
		cell.canBeBuiltUpon = false;
		cell.debugBodyColor = 16711935;
		cell.scene.cellsThatCanBeBuiltUponVerticallyGroup.remove(cell);
		cell.scene.cellsThatCanBeBuiltUponToTheRightGroup.remove(cell);

		// Cells in the same column as the touched cell are no longer buildable to the right.
		var childrenCellsBuildableToTheRight = cell.scene.cellsThatCanBeBuiltUponToTheRightGroup.getChildren();
		for (var i = 0; i < childrenCellsBuildableToTheRight.length; i++)
		{
			if (cell.columnNumber == childrenCellsBuildableToTheRight[i].columnNumber)
			{
				cell.scene.cellsThatCanBeBuiltUponToTheRightGroup.remove(childrenCellsBuildableToTheRight[i]);
			}
		}

		var recentlyChangedTargetTimer = worker.scene.time.addEvent(
			{
				delay: 5000,
				callback: function targetNoLongerRecentlyChanged() {
					worker.recentlyTouchedBuilableCell = false;
				},

				callbackScope: this,
				loop: false
			}
		);

		// Worker changes target to honey
		if (worker.scene.honeysGroup.children.entries.length > 0)
		{
			worker.target = Phaser.Math.RND.pick(worker.scene.honeysGroup.children.entries);
			worker.task = 'Heading to eat honey.';
		} else if (worker.recentlyChangedTargetTimer == false)
		{
			worker.target = Phaser.Math.RND.pick(worker.scene.cellsGroup.children.entries);
			worker.task = 'Heading to a hive cell.';
		}

	} else if (worker.role == 'builder' && worker.isHungry == true)
	{
		if (worker.scene.honeysGroup.children.entries.length > 0)
		{
			worker.target = Phaser.Math.RND.pick(worker.scene.honeysGroup.children.entries);
			worker.task = 'Heading to eat honey.';
		}
		else if (worker.recentlyChangedTargetTimer == false)
		{
			worker.target = Phaser.Math.RND.pick(worker.scene.cellsGroup.children.entries);
			worker.task = 'Heading to a hive cell.';
		}
	}
}

export function workerTouchedCellThatCanBeBuiltUponToTheLeft(worker, cell)
{
	if (worker.role == 'builder' && worker.isHungry == false && worker.recentlyTouchedBuilableCell == false)
	{
		worker.recentlyTouchedBuilableCell = true;
		worker.numberOfCellsWorkerCanBuildBeforeEating -= 1;
		if (worker.numberOfCellsWorkerCanBuildBeforeEating = 0)
		{
			worker.isHungry = true;
		}

		var builtCell;

		// New cell gets created to the right of the cell.
		cell.scene.cells.push( builtCell = new classes.Cells(
			cell.scene,
			cell.x - (cell.width - 18),
			cell.y + 25,
			this,
			'empty',
			true,
			cell.columnDirection,
			cell.scene.username,
			worker.species
		) );

		// Newest cell can be a builder target.
		// builtCell.canBeBuiltUpon = true;
		// builtCell.direction = cell.direction;
		builtCell.debugBodyColor = 0;
		builtCell.columnNumber = cell.columnNumber - 1;
		cell.scene.cellsThatCanBeBuiltUponVerticallyGroup.add(builtCell.cellSprite);
		cell.scene.cellsThatCanBeBuiltUponToTheLeftGroup.add(builtCell.cellSprite);

		// Touched cell is no longer buildable.
		cell.canBeBuiltUpon = false;
		cell.debugBodyColor = 16711935;
		cell.scene.cellsThatCanBeBuiltUponVerticallyGroup.remove(cell);
		cell.scene.cellsThatCanBeBuiltUponToTheLeftGroup.remove(cell);

		// Cells in the same column as the touched cell are no longer buildable to the right.
		var childrenCellsBuildableToTheLeft = cell.scene.cellsThatCanBeBuiltUponToTheLeftGroup.getChildren();
		for (var i = 0; i < childrenCellsBuildableToTheLeft.length; i++)
		{
			if (cell.columnNumber == childrenCellsBuildableToTheLeft[i].columnNumber)
			{
				cell.scene.cellsThatCanBeBuiltUponToTheLeftGroup.remove(childrenCellsBuildableToTheLeft[i]);
			}
		}

		// Worker changes target to new buildable cell.
		// worker.target = Phaser.Math.RND.pick(worker.scene.cellsThatCanBeBuiltUponVerticallyGroup.children.entries);

		var recentlyChangedTargetTimer = worker.scene.time.addEvent(
			{
				delay: 5000,
				callback: function targetNoLongerRecentlyChanged() {
					worker.recentlyTouchedBuilableCell = false;
				},
				callbackScope: this,
				loop: false
			}
		);

		if (worker.scene.honeysGroup.children.entries.length > 0)
		{
			worker.target = Phaser.Math.RND.pick(worker.scene.honeysGroup.children.entries);
			worker.task = 'Heading to a eat honey cell.';
		} else
		{
			worker.target = Phaser.Math.RND.pick(worker.scene.cellsGroup.children.entries);
			worker.task = 'Heading to a hive cell.';
		}

	} else if (worker.role == 'builder' && worker.isHungry == true)
	{
		if (worker.scene.honeysGroup.children.entries.length > 0)
		{
			worker.target = Phaser.Math.RND.pick(worker.scene.honeysGroup.children.entries);
			worker.task = 'Heading to eat honey.';
		} else if (worker.recentlyChangedTargetTimer == false)
		{
			worker.target = Phaser.Math.RND.pick(worker.scene.cellsGroup.children.entries);
			worker.task = 'Heading to a hive cell.';
		}
	}
}

export function cellTouchedCell(cell1, cell2)
{
	// cell2.destroy();
}

export function queenBeeBotTouchedCell(queenBeeBot, cell)
{
	if (queenBeeBot.task == 'headingToNearestCell' && !queenBeeBot.targetRecentlyChanged)
	{
		queenBeeBot.targetRecentlyChanged = true;
		var recentlyChangedTargetTimer = queenBeeBot.scene.time.addEvent(
			{
				delay: 10000,
				callback: function targetNoLongerRecentlyChanged() {
					queenBeeBot.targetRecentlyChanged = false;
					queenBeeBot.task = 'layingEggs';
				},
				callbackScope: this,
				loop: false
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/modules/colliderCallbacks.js